import {inject, Pipe, PipeTransform} from '@angular/core';
import {ThemeService} from '../services/theme/theme.service';

@Pipe({ name: 'darkModeEnabled' })
export class DarkModeEnabledPipe implements PipeTransform {
    private readonly themeService: ThemeService = inject(ThemeService);

    public transform<T>(darkMode: unknown, normalMode: T): T {
        const isDarkModeEnabled = this.themeService.getIsDarkModeSignal();
        return isDarkModeEnabled() ? darkMode as T : normalMode;
    }
}
